<div class="plot-card">
    <div class="plot-header" jhiTranslate="field-manager.plot-details.title">Plot Details</div>
    <table class="plot-details">
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.crop">Crop</td>
            <td>
                <div class="value-chip">{{ details?.crop || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.program">Program</td>
            <td>
                <div class="value-chip">{{ details?.program || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.study">Study</td>
            <td>
                <div class="value-chip">{{ details?.studyName || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.environment.no">Environment No</td>
            <td>
                <div class="value-chip">{{ details?.environmentNumber || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.germplasm.name">Germplasm Name</td>
            <td>
                <div class="value-chip">{{ details?.germplasmName || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.replicate">Replicate</td>
            <td>
                <div class="value-chip">{{ details?.replicate || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.block">Block</td>
            <td>
                <div class="value-chip">{{ details?.block || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.row.col">Row, Col</td>
            <td>
                <div class="value-chip">{{ details?.rowCol || '-' }}</div>
            </td>
        </tr>
        <tr>
            <td jhiTranslate="field-manager.plot-details.column.plot.no">Plot #</td>
            <td>
                <div class="value-chip">{{ details?.plotNumber || '-' }}</div>
            </td>
        </tr>
    </table>
</div>
